<button pButton pRipple type="button" icon="fal fa-info" (click)="showDetailsDialog()"
    class="p-button-rounded p-button-info tw-mr-1" [ngClass]="{ 'HighThreat' : approvalItem.ThreatLevel == 'High' }"
    [pTooltip]="getToolTip(approvalItem)" tooltipPosition="left"></button>

<p-dialog *ngIf="showDialog" [(visible)]="showDialog" appendTo="body" modal="true" [resizable]="false"
    [style]="{width: '60%', height: '80vh'}">
    <ng-template pTemplate="header">
        <section class="page-header">
            <h1 class="page-title"><em class="fal fa-sliders tw-mr-2"></em>Medicaid End Date Outliers for '{{
                approvalItem.state }}' and contract '{{ approvalItem.hContract}}'</h1>
        </section>
    </ng-template>

    <div class="tw-w-full tw-flex tw-flex-col" *ngIf="approvalItem && !showEndDateDetails">
        <div class="tw-w-full tw-flex tw-flex-col">
            <div class="tw-w-full tw-grid tw-grid-cols-12 tw-pb-2 tw-pt-1">
                <div class="tw-col-span-8 tw-text-lg">
                </div>
                <div class="tw-col-span-1 tw-text-lg tw-text-right">
                    <b>Average :</b>
                </div>
                <div class="tw-col-span-1 tw-text-lg tw-text-center">
                    {{ meanValue }}
                </div>
                <div class="tw-col-span-1 tw-text-lg tw-text-right">
                    <b>Threshold :</b>
                </div>
                <div class="tw-col-span-1 tw-text-lg tw-text-center" [pTooltip]="thresholdTooltip">
                    {{ threshold + meanValue | number:'.0-2' }}
                </div>
            </div>
            <div class="tw-w-full tw-grid tw-grid-cols-4">
                <div class="tw-col-span-1 tw-w-32">
                    <strong>File Date</strong>
                </div>
                <div class="tw-col-span-1 tw-w-48">
                    <b>End Date</b>
                </div>
                <div class="tw-col-span-1 tw-w-16">
                    <b>Count</b>
                </div>
                <div></div>
            </div>
            <div class="tw-w-full tw-basis-[200px] tw-overflow-y-scroll">
                <div class="tw-w-full tw-grid tw-grid-cols-4" *ngFor="let item of approvalItem.outliers">
                    <div class="tw-col-span-1 tw-w-32 tw-content-center">
                        {{ item.fileGenerationDate | date:'MM/dd/yyyy' }}
                    </div>
                    <div class="tw-col-span-1 tw-w-48 tw-flex tw-content-center">
                        <div class="tw-w-1/2 tw-content-center">
                            {{ item.medicaidStatusEndDate | date:'MM/dd/yyyy' }}
                        </div>
                        <div class="tw-text-right tw-justify-end tw-text-xs tw-w-1/2 tw-content-center">
                            <p-button icon="fa fa-plus"
                                styleClass="p-button-rounded p-button-danger p-button-text tw-text-blue-500"
                                (onClick)="addEndDateClicked(item)"
                                pTooltip="Add Date to Exlusions List for approval file."
                                [disabled]="endDateClicked(item)" tooltipPosition="left"></p-button>
                        </div>
                    </div>
                    <div class="tw-col-span-1 tw-w-16 tw-content-center">
                        <div class="tw-text-right tw-w-1/4">{{ item.occurrenceCount }}</div>
                    </div>
                    <div class="tw-col-span-1 tw-w-36 tw-flex tw-content-center">
                        <div class="tw-text-center tw-w-1/2">
                            <p-button icon="fa fa-ellipsis"
                                styleClass="p-button-rounded p-button-danger p-button-text tw-text-blue-500"
                                (onClick)="showDetails(item)" pTooltip="See Medicaid end dates."
                                tooltipPosition="left"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tw-w-full tw-flex tw-grow">
            <p-chart type="bar" [data]="chartData" [options]="chartOptions" width="100%" height="100%"
                class="tw-w-full tw-flex tw-grow"></p-chart>
        </div>
    </div>
    <div class="tw-flex tw-flex-col tw-h-full tw-w-full" *ngIf="showEndDateDetails">
        <div class="tw-flex tw-basis-full tw-w-full tw-flex-col">
            <p-table #dtEndDates [value]="endDates" [scrollable]="true" scrollHeight="flex"
                [columns]="endDateDetailColumns" class="tw-w-full tw-h-full">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th>State</th>
                        <th>MemberId</th>
                        <th>MBI</th>
                        <th>HContract</th>
                        <th>End Date</th>
                        <th>File Date</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-entry>
                    <tr>
                        <td>{{ entry.state }}</td>
                        <td>{{ entry.memberId }}</td>
                        <td>{{ entry.hicn }}</td>
                        <td>{{ entry.hContract }}</td>
                        <td>{{ entry.medicaidStatusEndDate | date:'MM/dd/yyyy' }}</td>
                        <td>{{ entry.fileGenerationDate | date:'MM/dd/yyyy' }} </td>
                    </tr>
                </ng-template>
            </p-table>
            <div class="tw-w-full tw-text-right">
                <p-button icon="fa fa-download" (onClick)="export()" label="Export" class="tw-mr-2"></p-button>
                <p-button icon="fa fa-arrow-left" (onClick)="showEndDateDetails = false" label="Back"></p-button>
            </div>
        </div>
    </div>
</p-dialog>
